import { observer } from "mobx-react-lite";
import { useStores } from "stores";
import { ConfirmationModal, confirmationModalConfigs } from "components/ActionModals/ConfirmationModal";
import { approveWalletCheck } from "services";
import { CustomButton } from "ui";

interface IProps {
  onSuccess?: () => void;
  checkId: string;
}

export const ApproveWalletCheckButton = observer((props: IProps) => {
  const { actionModals, bidCard } = useStores();

  const approveCheckHandler = () => {
    actionModals.open(
      () => (
        <ConfirmationModal
          buttonText="Одобрить"
          text="Вы действительно хотите одобрить кошелек?"
          successText="Кошелек одобрен"
          calledQuery={() => approveWalletCheck({ checkId: props.checkId })}
          onSuccess={() => {
            setTimeout(() => {
              bidCard.updateCardById(bidCard.bid.id);
              if (props.onSuccess) {
                props.onSuccess();
              }
            }, 1500);
          }}
        />
      ),
      {
        ...confirmationModalConfigs,
        title: "Одобрение кошелька",
        onClose: () => actionModals.closeAll(),
      }
    );
  };

  return (
    <CustomButton type="default" size="small" onClick={approveCheckHandler}>
      Одобрить риски
    </CustomButton>
  );
});
